<template>
  <div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.INN_PIN }}</p>
      <p class="min-h-6">{{ person?.pin }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.SURNAME }}</p>
      <p class="min-h-6">{{ person?.surname }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.NAME }}</p>
      <p class="min-h-6">{{ person?.name }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.PATRONYMIC }}</p>
      <p class="min-h-6">{{ person?.patronymic }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.BIRTH_DATE }}</p>
      <p class="min-h-6">
        {{person?.birthDate ? $moment(person?.birthDate).format('DD.MM.YYYY') : '' }}
      </p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.CITIZENSHIP }}</p>
      <p class="min-h-6">{{ citizenships.find(c => c.id === person?.citizenship)?.label }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.ADDRESS }}</p>
      <p class="min-h-6">{{ person?.address?.address }}</p>
      <hr />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    person: Object,
    citizenships: Array,
  }
}
</script>